import { render, staticRenderFns } from "./Doclibrarary.vue?vue&type=template&id=7567bb6b&scoped=true&"
import script from "./Doclibrarary.vue?vue&type=script&lang=js&"
export * from "./Doclibrarary.vue?vue&type=script&lang=js&"
import style0 from "./Doclibrarary.vue?vue&type=style&index=0&id=7567bb6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567bb6b",
  null
  
)

export default component.exports